import { TaskVariant } from "@/pages/get-don/tasks.types";
import EyeIcon from "@/assets/icons/eye.svg?react";
import DownloadIcon from "@/assets/icons/download.svg?react";

const iconMap: Partial<
  Record<
    TaskVariant,
    React.FunctionComponent<
      React.ComponentProps<"svg"> & {
        title?: string;
        titleId?: string;
        desc?: string;
        descId?: string;
      }
    >
  >
> = {
  [TaskVariant.GotoLink]: EyeIcon,
  [TaskVariant.ViewStory]: EyeIcon,
  [TaskVariant.TelegramChatJoin]: DownloadIcon,
  [TaskVariant.ExternalTask]: DownloadIcon,
  [TaskVariant.OptionTask]: DownloadIcon,
  [TaskVariant.Keyword]: EyeIcon,
  [TaskVariant.Ads]: EyeIcon,
};

export { iconMap };
